export enum EventType {
  ALL = '**',

  PUSH_INVOICE_TO_ACCOUNTING = 'push.invoice.to.accounting',
  UPDATE_INVOICE_IN_ACCOUNTING = 'update.invoice.in.accounting',
  PUSH_CUSTOMER_TO_ACCOUNTING = 'push.customer.to.accounting',
  UPDATE_CUSTOMER_IN_ACCOUNTING = 'update.customer.in.accounting',
  PUSH_ACCOUNT_TO_ACCOUNTING = 'push.account.to.accounting',
  UPDATE_ACCOUNT_IN_ACCOUNTING = 'update.account.in.accounting',
  PUSH_ITEM_TO_ACCOUNTING = 'push.item.to.accounting',
  UPDATE_ITEM_IN_ACCOUNTING = 'update.item.in.accounting',
  PUSH_PAYMENT_TO_ACCOUNTING = 'push.payment.to.accounting',
  OBJECT_SYNCED_FROM_ACCOUNTING = 'object.synced.from.accounting',

  SEND_INVOICE_BY_EMAIL = 'send.invoice.by.email',
  SEND_CREDIT_BY_EMAIL = 'send.credit.by.email',
  CHANGED_INTEGRATION_ACCOUNT = 'changed.integration.account',
  INTEGRATION_DATA_SYNCED = 'integration.data.synced',
  INTEGRATION_DATA_TYPE_SYNCED = 'integration.data.type.synced',
  NEW_CONTRACT_IMPORTED = 'new.contract.imported',
  NEW_USAGE_REPORT_IMPORTED = 'new.usage.report.imported',
  PDF_GENERATION_BULK = 'pdf.generation.bulk',
  PDF_GENERATION_COMPLETED = 'pdf.generation.completed',
  PDF_GENERATION_FAILED = 'pdf.generation.failed',
  INVOICE_CHARGE_COMPLETED = 'invoice.charge.completed',

  SEND_DOCUMENTS = 'send.documents',
  CHARGE_INVOICES = 'charge.invoices',
}
